import React, {Component} from "react";
import {createBrowserHistory} from "history";
import {Redirect, Route as NeutralRoute, Router, Switch} from "react-router-dom";
import Login from "./views/login";
import ResetPassword from "./views/reset-password";
import HomeView from "./views/home";
import ResetPasswordConfirm from "./views/reset-password-confirm";
import LocalStorage from "./util/localStorage";
import NotFoundView from "./views/not-found";
import {hideModals} from "./data/actions/ui";
import RegisterView from "./views/register";
import ClientsView from "./views/clients";
import AssessmentsView from "./views/assessments";
import SetsView from "./views/sets";
import ReportView from "./views/report";
import QuizzView from "./views/quizz";
import ReportDocumentsView from "./views/report-documents";
import ReportGroupsView from "./views/report-groups";
import UsersPage from "./views/users-page";
import SettingsPage from "./views/settings-page";
import LoggedDevicesPage from "./views/logged-devices-page";

const PrivateRoute = ({component: Component, ...rest}) => (
    <NeutralRoute
        {...rest}
        render={props =>
            (!!LocalStorage.get('user')) ? (<Component {...props}/>) : (
                <Redirect to={{
                    pathname: "/login",
                    state: {from: props.location}
                }}/>
            )
        }
    />
);

const PublicRoute = ({component: Component, ...rest}) => (
    <NeutralRoute
        {...rest}
        render={props =>
            (!LocalStorage.get('user')) ? (<Component {...props}/>) : (
                <Redirect to={{
                    pathname: "/clients",
                    state: {from: props.location}
                }}/>
            )
        }
    />
);

class IdleModal extends Component {
    constructor(props) {
        super(props);
        this.unlisten = null;
        this.state = {}
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            this.props.dispatch(hideModals());

        });
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
    }

    render() {
        return (
            <React.Fragment>
            </React.Fragment>
        );
    }
}

class RouterListener extends Component {

    constructor(props) {
        super(props);

        this.unlisten = null;
        this.state = {}
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {

        });
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }
}

export default (store, translator) => {
    function getComponent(Component, props) {
        return (
            <Component {...props} translate={(key, args) => translator.translate(key, args)}/>
        );
    }

    const history = createBrowserHistory();
    store.history = history;

    return (
        <Router history={history}>
            <RouterListener history={history} dispatch={store.dispatch} {...store.getState()}
                            translate={(key, args) => translator.translate(key, args)}>
                <Switch>
                    <PublicRoute exact path="/" component={(props) => getComponent(Login, props)}/>
                    <PublicRoute exact path="/login" component={(props) => getComponent(Login, props)}/>

                    <PublicRoute exact path="/register" component={(props) => getComponent(RegisterView, props)}/>
                    <PublicRoute exact path="/reset-password"
                                 component={(props) => getComponent(ResetPassword, props)}/>
                    <NeutralRoute exact path="/reset-password-confirm/:email/:token/:is_new"
                                  component={(props) => getComponent(ResetPasswordConfirm, props)}/>

                    <PrivateRoute exact path="/home" component={(props) => getComponent(HomeView, props)}/>
                    <PrivateRoute exact path="/lookup" component={(props) => getComponent(SettingsPage, props)}/>
                    <PrivateRoute exact path="/clients" component={(props) => getComponent(ClientsView, props)}/>
                    <PrivateRoute exact path="/users" component={(props) => getComponent(UsersPage, props)}/>
                    <PrivateRoute exact path="/assessments"
                                  component={(props) => getComponent(AssessmentsView, props)}/>
                    <PrivateRoute exact path="/sets" component={(props) => getComponent(SetsView, props)}/>
                    <PrivateRoute exact path="/report/:id" component={(props) => getComponent(ReportView, props)}/>
                    <PrivateRoute exact path="/documents/:id"
                                  component={(props) => getComponent(ReportDocumentsView, props)}/>
                    <PrivateRoute exact path="/groups/:id"
                                  component={(props) => getComponent(ReportGroupsView, props)}/>
                    <PrivateRoute exact path="/report/start/:id" component={(props) => getComponent(QuizzView, props)}/>

                    <PrivateRoute exact path="/devices" component={(props) => getComponent(LoggedDevicesPage, props)}/>

                    <NeutralRoute component={(props) => getComponent(NotFoundView, props)}/>
                </Switch>
            </RouterListener>
            <IdleModal
                history={history} dispatch={store.dispatch}
                translate={(key, args) => translator.translate(key, args)}/>
        </Router>
    );
}
